/**
 * src/components/promos/Promos.js
 *
 * Sección de promociones en la página principal.
 * Fetchea /data/promos.json directamente para reflejar cambios del admin.
 */

import { define, c } from '@components/Component.js'
import { h } from '@core/dom.js'

const DEFAULT_SECTION = {
    label:       'Promociones y novedades',
    headline:    'Promociones y novedades en Fusagasugá',
    description: 'Descubre descuentos, lanzamientos y beneficios de negocios locales desde UBIYAAA.',
    cta:         { label: 'Ver promociones', href: '/promociones' }
}

function shuffle(arr) {
    for (let i = arr.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [arr[i], arr[j]] = [arr[j], arr[i]]
    }
    return arr
}

define('Promos', () => {
    const root = h('section', { className: 'promos' })

    fetch(`/data/promos.json?t=${Date.now()}`)
        .then(r => r.json())
        .then(data => {
            const section = (data.section && data.section.cta) ? data.section : DEFAULT_SECTION
            const items   = shuffle((data.items || []).filter(p => p.enabled !== false))
            root.appendChild(
                h('div', { className: 'promos__inner' },
                    c('PromosHeader', section),
                    c('PromosCarousel', { items })
                )
            )
        })
        .catch(() => {
            // Fallback si el fetch falla: mostrar sección con datos por defecto vacíos
            root.appendChild(
                h('div', { className: 'promos__inner' },
                    c('PromosHeader', DEFAULT_SECTION),
                    c('PromosCarousel', { items: [] })
                )
            )
        })

    return root
})
